var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFieldModifier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85755 32.8799L0 32.8799L3.56314e-07 2.99999C3.76072e-07 1.34314 1.34315 -7.61338e-06 3 -7.59362e-06L32.8537 -7.23762e-06L32.8537 12.6671L32.8537 20.4911L32.8537 32.8799L25.1606 32.8799L25.1606 31.3152C25.1606 25.0218 20.4672 21.9075 16.6617 21.9075C12.6448 21.9075 7.85755 25.0218 7.85755 31.3152L7.85755 32.8799Z",
    fill: "#475161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8799 71.9998V64.1422V46.8392V39.1461L20.4911 39.1461V31.3238C20.4911 28.7317 19.2775 26.5967 16.6848 26.5967C14.0922 26.5967 12.6671 28.7317 12.6671 31.3238L12.6671 39.1461L0 39.1461L3.55243e-06 68.9998C3.69727e-06 70.6566 1.34315 71.9998 3 71.9998H9.00001V69.9998H9.01447C9.00488 69.8343 9.00001 69.6676 9.00001 69.4998C9.00001 64.8054 12.8056 60.9998 17.5 60.9998C22.1944 60.9998 26 64.8054 26 69.4998C26 69.6676 25.9951 69.8343 25.9855 69.9998H26V71.9998H32.8799Z",
    fill: "#475161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 7.5C39 5.84315 40.3431 4.5 42 4.5H69C70.6569 4.5 72 5.84315 72 7.5C72 9.15685 70.6569 10.5 69 10.5H42C40.3431 10.5 39 9.15685 39 7.5Z",
    fill: "#475161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 22.5C39 20.8431 40.3431 19.5 42 19.5H69C70.6569 19.5 72 20.8431 72 22.5C72 24.1569 70.6569 25.5 69 25.5H42C40.3431 25.5 39 24.1569 39 22.5Z",
    fill: "#475161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 49.5C39 47.8431 40.3431 46.5 42 46.5H69C70.6569 46.5 72 47.8431 72 49.5C72 51.1569 70.6569 52.5 69 52.5H42C40.3431 52.5 39 51.1569 39 49.5Z",
    fill: "#475161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 64.5C39 62.8431 40.3431 61.5 42 61.5H69C70.6569 61.5 72 62.8431 72 64.5C72 66.1569 70.6569 67.5 69 67.5H42C40.3431 67.5 39 66.1569 39 64.5Z",
    fill: "#475161"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldModifier);
export default __webpack_public_path__ + "static/media/Field_Modifier.91add4d85ed0ae7bf6437a94bb9ab1d5.svg";
export { ForwardRef as ReactComponent };